import { type FunctionComponent, type PropsWithChildren } from 'react';
import { getLinkStyles } from '../../../helpers/link-style/link-style';
import { Link, type LinkProps } from './link.component';
import type { LinkStyleProps } from './link.types';

export type StyledLinkProps = PropsWithChildren<LinkStyleProps & LinkProps>;

const normalizeUtilityClass = (utilityClass: string) => utilityClass.replace(/!$/, '');

const shouldKeepUnderlineClass = (utilityClass: string, underline: boolean | undefined, underlineHover: boolean | undefined) => {
	const normalizedClass = normalizeUtilityClass(utilityClass);

	if (underline === false && normalizedClass === 'underline') return false;
	if (underline === true && normalizedClass === 'no-underline') return false;
	if (underlineHover === false && normalizedClass === 'underline-hover') return false;
	if (underlineHover === true && normalizedClass === 'no-underline-hover') return false;

	return true;
};

/**
 * A Link that supports visual enhancements (color, underline etc.)
 */
export const StyledLink: FunctionComponent<StyledLinkProps> = ({
	color = 'primary',
	className = '',
	underline,
	underlineHover,
	...restProps
}) => {
	const linkStyles = getLinkStyles(color)
		.split(' ')
		.filter(Boolean)
		.filter((utilityClass) => shouldKeepUnderlineClass(utilityClass, underline, underlineHover))
		.join(' ');

	return (
		<Link
			isStyledLink
			className={`${linkStyles} ${className}`.trim()}
			color={color}
			underline={underline}
			underlineHover={underlineHover}
			{...restProps}
		/>
	);
};
